export class SHMError extends Error {
    /**
     * please use SHMError.create to construct an error
     * @param message
     * @param code
     * @param error
     * @param extra
     */
    constructor(message, code, error, extra) {
        super(message !== null && message !== void 0 ? message : 'unknown error');
        this.name = 'SHMError';
        this.code = code || 2 /* Code.UNKNOWN */;
        this.innerError = error;
        this.extra = extra;
    }
    /**
     * alias of message field
     */
    get msg() {
        return this.message;
    }
    /**
     * alias of message field
     */
    set msg(val) {
        this.message = val;
    }
    /**
     * complete message that includes messages from innerError
     */
    get completeMessage() {
        if (!this.innerError) {
            return this.message;
        }
        if (this.innerError instanceof SHMError) {
            return `${this.message} - (${this.innerError.code})${this.innerError.completeMessage}`;
        }
        return `${this.message} - ${this.innerError.message}`;
    }
    /**
     * get extra data
     */
    getExtra() {
        return this.extra;
    }
    /**
     * create an SHMError instance
     * @param err
     */
    static create(err) {
        var _a;
        if (!err) {
            return new SHMError();
        }
        if (err instanceof SHMError) {
            return err;
        }
        if (err instanceof Error) {
            return new SHMError(err.message, err.code, err);
        }
        switch (typeof err) {
            case 'string':
                return new SHMError(err);
            case 'object':
                return new SHMError((_a = err.message) !== null && _a !== void 0 ? _a : err.msg, err.code, err.error, err.extra);
            default:
                break;
        }
        return new SHMError();
    }
}
